import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SaffronButtonComponent } from './components/saffron-button/saffron-button.component';
import { RouterModule } from '@angular/router';
import { ToasterComponent } from './components/toaster/toaster.component';
import { LoadingComponent } from './components/loading/loading.component';
import { RoleAccessDirective } from './directives/role-access.directive';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { AddHouseholdMemberModalComponent } from './components/modal/add-household-member-modal/add-household-member-modal.component';
import { FirmContextPickerComponent } from './components/firm-context-picker/firm-context-picker.component';
import { HouseholdPickerComponent } from './components/household-picker/household-picker.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppShellComponent } from './components/app-shell/app-shell.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { FirmPickerModalComponent } from './components/firm-picker-modal/firm-picker-modal.component';
import { NewHouseholdComponent } from './components/new-household/new-household.component';
import { DisplayOrgNamePipe } from './pipes/display-org-name.pipe';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { AiBudgetCardComponent } from './components/ai-budget-card/ai-budget-card.component';
import { EditOrgBudgetModalComponent } from './components/edit-org-budget-modal/edit-org-budget-modal.component';

@NgModule({
  declarations: [
    SaffronButtonComponent,
    FirmContextPickerComponent,
    HouseholdPickerComponent,
    ToasterComponent,
    LoadingComponent,
    RoleAccessDirective,
    UnauthorizedComponent,
    AddHouseholdMemberModalComponent,
    PaginationComponent,
    AppShellComponent,
    SideNavComponent,
    FirmPickerModalComponent,
    NewHouseholdComponent,
    DisplayOrgNamePipe,
    ProgressBarComponent,
    AiBudgetCardComponent,
    EditOrgBudgetModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    SaffronButtonComponent,
    ToasterComponent,
    LoadingComponent,
    RoleAccessDirective,
    UnauthorizedComponent,
    AddHouseholdMemberModalComponent,
    FirmContextPickerComponent,
    HouseholdPickerComponent,
    PaginationComponent,
    AppShellComponent,
    SideNavComponent,
    FirmPickerModalComponent,
    NewHouseholdComponent,
    DisplayOrgNamePipe,
    ProgressBarComponent,
    AiBudgetCardComponent,
    EditOrgBudgetModalComponent,
  ]
})
export class SharedModule { }
